import styled from '@emotion/styled';

import { su } from '../../theme/functions/su';

import { InsightListItem } from './InsightListItem';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${su(0, 2)};
`;

const Item = styled.div`
  padding: ${su(1, 0)};
`;

const insightList = (
  <Container>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
    <Item>
      <InsightListItem />
    </Item>
  </Container>
);

export function InsightList() {
  return insightList;
}
